export default __webpack_public_path__ + "static/img-art-pandas-profiling-9-1bcfa7712327d34d67a58c7a7b77283e.png";